<div class="overdue-label" *ngIf="event.overdue > 0"></div>

<div class="eventDescription">
  <div class="eventTime">
    {{ event.StartTime | moment: 'HH:mm' }} -
    {{ event.EndTime | moment: 'HH:mm' }}
  </div>
  <app-calendar-event-icons [event]="event"></app-calendar-event-icons>
</div>
<div class="eventPostCode" *ngIf="event.postcode">
  {{ event.postcode }}
</div>
<div class="eventBusiness" *ngIf="event.business">
  {{ event.business }}
</div>
<div
  class="eventProjectStatus"
  *ngIf="event.projectStatus || event.financialStatus"
>
  <ng-container *ngIf="event.projectStatus">{{
    event.projectStatus
  }}</ng-container>
  <ng-container *ngIf="event.financialStatus">
    - {{ event.financialStatus }}</ng-container
  >
</div>
<div class="eventBilling" *ngIf="event.billingContactName">
  <ng-container *ngIf="event.customerCompanyName?.length > 2"
    >{{ event.customerCompanyName }} -</ng-container
  >
  {{ event.billingContactName }}
</div>
<div class="eventTechnicians" *ngIf="event.TechnicianNames.length">
  {{ event.TechnicianNames }}
</div>
<div class="eventAddress" *ngIf="this.utils.formatAddress(event)">
  {{ this.utils.formatAddress(event) }}
</div>
<div class="eventSubject">{{ event.Subject }}</div>
